import { Component } from '@angular/core';
import { AddChartComponent } from '../add-chart/add-chart.component';
import { UserDashboardService } from '../../../services/user-dashboard.service';
import { Router } from '@angular/router';

@Component({
  selector: 'create-dashboard',
  standalone: true,
  imports: [AddChartComponent],
  templateUrl: './create-dashboard.component.html',
  styleUrl: './create-dashboard.component.scss',
})
export class CreateDashboardComponent {
  constructor(private userDashboardService: UserDashboardService, private router: Router) {}
  handleCancel() {
    this.router.navigate(['user-dashboard']);
  }
}
